export const GODS = [
  {
    id: "zeus",
    name: "Zeus",
    sigil: "Z",
    domain: "King of Sky · Thunder & Lightning",
    ac: "+3 AC",
    color: "#5BA3D0",
    abilities: [
      {
        name: "Lightning Bolt",
        cost: "5 Δ",
        action: "Action",
        range: "30 ft",
        effect:
          "Strike one enemy for 1d8 lightning. Bolt jumps to one foe within 10 ft for 1d4 damage.",
        levels: [
          "Damage → 1d10. On a failed roll, target becomes Exposed.",
          "Lightning jumps to two enemies instead of one.",
          "Damage → 2d8. Exposed enemies take +1d6 lightning.",
          "+5 Δ to Stun target on failed roll. Bosses become Exposed unless below half HP.",
        ],
      },
      {
        name: "Thunder",
        cost: "8 Δ",
        action: "Minor Action",
        range: "Self",
        duration: "3 turns",
        effect:
          "Body crackles with divine thunder. Your attacks deal +1d6 lightning damage.",
        levels: [
          "On damage, push enemy back 5 ft once per turn.",
          "Gain +2 AC while Thunder is active.",
          "Enemies who hit you in melee take 1d6 lightning.",
          "Reaction: automatically counterattack for 2d6 lightning.",
        ],
      },
      {
        name: "Mimicry",
        cost: "6 Δ",
        action: "Action",
        range: "Self",
        duration: "3 turns",
        effect:
          "Transform: Eagle (fly 30 ft, +1d6 after move) · Bull (10 Guard, push 10 ft) · Serpent (squeeze gaps, poison 1d4 for 2 turns).",
        levels: [
          "Duration → 4 turns.",
          "Switch form once as Minor Action.",
          "+1d8 instead of +1d6 on form attacks.",
          "Once per battle: all allies transform for 2 turns.",
        ],
      },
    ],
  },
  {
    id: "athena",
    name: "Athena",
    sigil: "A",
    domain: "Mind of War · Wisdom & Strategy",
    ac: "+3 AC",
    color: "#D4AF37",
    abilities: [
      {
        name: "The Mind",
        cost: "6 Δ",
        action: "Minor Action",
        range: "Visible enemy",
        duration: "2 turns",
        effect:
          "Pick a visible enemy. GM reveals if they will attack, defend, move, or use a special ability next turn.",
        levels: [
          "Give info to ally within 20 ft → +2 AC vs that enemy's next attack.",
          "Use as Reaction when targeted.",
          "Chosen enemy becomes Exposed if they attack you or an ally.",
          "Once per battle: fully predict — you or one ally completely avoid that enemy's next attack.",
        ],
      },
      {
        name: "Aegis",
        cost: "5 Δ",
        action: "Reaction",
        range: "10 ft",
        effect: "When you or an ally within 10 ft takes damage, reduce it by 1d8 + your level.",
        levels: [
          "Damage reduced to 0 → attacker becomes Exposed.",
          "Range → 20 ft.",
          "Target also gains 5 Guard.",
          "Once per battle: reflect half the blocked damage at attacker.",
        ],
      },
      {
        name: "Owl's Blessing",
        cost: "6 Δ",
        action: "Action",
        range: "Attack target",
        duration: "3 turns",
        effect:
          "Attacks place Sleep Tokens. Asleep: lose next turn. First hit → double damage + wake.",
        levels: [
          "First hit each turn applies 2 tokens.",
          "Place 1 token on a second enemy within 10 ft.",
          "Sleeping enemies become Exposed after waking.",
          "Once per battle: enter an enemy's dream and make them attack their own ally.",
        ],
      },
    ],
  },
  {
    id: "poseidon",
    name: "Poseidon",
    sigil: "P",
    domain: "Lord of Seas · Tide & Storm",
    ac: "+3 AC",
    color: "#5BA3D0",
    abilities: [
      {
        name: "Water Bolt",
        cost: "5 Δ",
        action: "Action",
        range: "30 ft line",
        effect: "Line of water hits all enemies in the path for 1d6 water damage. Gain 1 Tide Charge if at least one enemy is hit.",
        levels: ["Damage → 1d8.", "Hit enemies pushed 5 ft.", "Hit 2+ enemies → gain 2 Tide Charges.", "Creates wet terrain. Lightning vs wet enemies deals +1d6."],
      },
      {
        name: "God's Steed",
        cost: "8 Δ",
        action: "Minor Action",
        range: "Self",
        duration: "4 turns",
        effect: "Summon a water steed. Gain +10 movement and 10 Guard.",
        levels: ["Once during duration: become a wave, move through enemies for 1d6 damage.", "Ignore difficult terrain.", "Allies you pass through gain 5 Guard.", "Once per battle: carry one ally during movement."],
      },
      {
        name: "Trishula",
        cost: "7 Δ + Tide Charges",
        action: "Action",
        range: "Melee / 10 ft AoE",
        effect: "Summon Poseidon's trident. 0 charges: 1d8 · 1 charge: 2d8 · 2 charges: 2d8 AoE 10 ft · 3 charges: 3d8 AoE + push 10 ft.",
        levels: ["3 charges → rain begins for 3 rounds.", "Rain: Water Bolt costs 3 Δ instead of 5.", "Rain: all water damage +1d6.", "Once per battle: spend 3 charges to summon a tidal wave across the battlefield."],
      },
    ],
  },
  {
    id: "hera",
    name: "Hera",
    sigil: "H",
    domain: "Queen of Heaven · Authority & Wrath",
    ac: "+3 AC",
    color: "#D06BA0",
    abilities: [
      { name: "Bonding", cost: "6 Δ", action: "Action", range: "30 ft", duration: "3 turns", effect: "Link two enemies within 20 ft. When one linked enemy takes damage, the other takes half that damage.", levels: ["Link enemies up to 15 ft apart.", "Link two allies instead — they split damage evenly.", "Link three targets instead of two.", "Once per battle: when one linked enemy is defeated, the other is Stunned."] },
      { name: "Mind Crush", cost: "8 Δ", action: "Action", range: "30 ft", duration: "2 turns", effect: "Target rolls d20. On a failed roll, they suffer Madness.", levels: ["Madness lasts 3 turns.", "If they hurt themselves, they become Exposed.", "Target two enemies.", "A severe Madness result Stuns instead of costing an Action."] },
      { name: "Family Matters", cost: "8 Δ", action: "Action", range: "20 ft aura", effect: "Allies gain 3 Δ and 5 Guard. Enemies roll d20 — on a failed roll, they gain Fear.", levels: ["Allies gain 5 Δ instead of 3.", "Fear becomes harder to resist.", "Allies remove one negative condition.", "Once per battle: all allies in range may move 10 ft or make one basic attack immediately."] },
    ],
  },
  {
    id: "demeter",
    name: "Demeter",
    sigil: "D",
    domain: "Hand of Harvest · Growth & Decay",
    ac: "+2 AC",
    color: "#6BAA5B",
    abilities: [
      { name: "Famine & Flourish", cost: "5 Δ", action: "Minor Action", range: "10 ft", effect: "Swap between Famine (enemies in 10 ft take 1d4/turn) and Flourish (allies gain 1d4 HP/turn).", levels: ["Roll d4 after swapping for bonus damage/healing.", "Range → 15 ft.", "On swap, one ally in range gains 5 Guard.", "Once per battle: Cycle of Seasons — both Famine and Flourish active simultaneously."] },
      { name: "Evergrowth", cost: "8 Δ", action: "Action", range: "10 ft", duration: "3 turns", effect: "Plant a seed that blooms into a 5 ft wheat patch. Allies who enter heal 1d6 HP. Persists 3 turns.", levels: ["Scarecrow absorbs 1d6 damage for allies hit in the field.", "Patch grows 5 ft → 10 ft.", "Foes entering are Rooted on a failed roll.", "Once per battle: allies in patch heal 2d6, gain 10 Guard, remove one condition — then patch vanishes."] },
      { name: "Sickle's Harvest", cost: "6 Δ", action: "Action", range: "10 ft", effect: "Summon a sickle for 1d6 damage + Poison (1d4 for 2 turns).", levels: ["Poison damage → 1d6.", "Target in Evergrowth or aura → +1d6 damage.", "Enemy defeated while poisoned → heal 1d4 HP.", "Once per battle — Reaper's Bloom: hit 3 enemies within 15 ft."] },
    ],
  },
  {
    id: "apollo",
    name: "Apollo",
    sigil: "O",
    domain: "Bringer of Light · Fire & Healing",
    ac: "+2 AC",
    color: "#E07B35",
    abilities: [
      { name: "Sol", cost: "8 Δ", action: "Action", range: "20 ft", effect: "Conjure a fireball and strike for 1d8 damage. Target rolls d20 — on failure, they Burn for 2 turns.", levels: ["Damage → 1d10.", "Target already Burning → Sol deals +1d6.", "Bounces to one enemy within 10 ft for 1d6.", "Once per battle — Dawn Spear: 3d8 to one enemy, Burning for 3 turns."] },
      { name: "Pandemonium", cost: "8 Δ", action: "Action", range: "15 ft", effect: "All enemies in range roll d20. On a failed roll, they become Dazed until end of their turn.", levels: ["Allies may choose to resist your song.", "Failed enemies also become Exposed for 1 turn.", "Range → 20 ft.", "Once per battle — Song of Ruin: failed enemies take 2d6 psychic/physical + Dazed."] },
      { name: "Psyche Ward", cost: "6 Δ", action: "Action", range: "Any visible ally", effect: "Strike any visible ally with a healing arrow for 1d6 HP + 3 Guard.", levels: ["After shooting, move an additional 10 ft in any direction.", "Healing → 1d8 and remove one status condition.", "Also grants +2 AC until your next turn.", "Once per battle — Golden Revival: 0 HP ally rises to 1 HP, heals 1d8, gains 10 Guard."] },
    ],
  },
  {
    id: "artemis",
    name: "Artemis",
    sigil: "R",
    domain: "Hunt's Eternal · Moon & Wild",
    ac: "+3 AC",
    color: "#8AC0E0",
    abilities: [
      { name: "Hunter's Prowess", cost: "7 Δ", action: "Action", range: "20 ft", duration: "3 turns", effect: "Conjure a bow persona. After your initial attack, the persona fires for 1d4 damage at an enemy within 20 ft.", levels: ["Bow damage → 1d6.", "The persona fires at two different enemies per trigger instead of one.", "On a d20 ≥18 hit, the arrow pins the target — they become Rooted for 1 turn.", "Once per battle — Arrow Storm: the persona unleashes a volley hitting every enemy within 30 ft for 2d6 damage."] },
      { name: "Moon's Guidance", cost: "10 Δ", action: "Action", range: "Self + allies", duration: "2 turns", effect: "Darkness falls. You and allies may roll to dodge any attack (d20 ≥15). Duration: 2 turns.", levels: ["After your dodge roll, make another attack.", "Dodge threshold drops from d20 ≥15 to d20 ≥12.", "Allies who successfully dodge gain a free 10 ft move that doesn't provoke opportunity attacks.", "Once per battle — Eclipse: duration extends to 3 turns, and all enemies within 30 ft become Blinded, making attacks at disadvantage for the duration."] },
      { name: "Lost Gaze", cost: "5 Δ", action: "Action", range: "Self", duration: "2 turns", effect: "Enter the secondary plane — invisible to enemies beyond 10 ft. Base attack damage +1d8.", levels: ["On attack, a wolf joins and deals 1d4 every time you attack.", "Wolf grows: damage increases to 1d6, and it can Howl once to inflict Fear on one enemy on a failed roll.", "Your first attack each turn while in the secondary plane deals double damage.", "Once per battle — Pack Call: summon three wolves for 2 turns. Each attacks independently for 1d4, and any one of them may Howl to apply Fear."] },
    ],
  },
  {
    id: "hephaestus",
    name: "Hephaestus",
    sigil: "F",
    domain: "Forge of Fire · Craft & Metal",
    ac: "+3 AC",
    color: "#C07050",
    abilities: [
      { name: "Metal Manipulation", cost: "4 Δ", action: "Minor Action", range: "Self", duration: "3 turns", effect: "Transform your weapon into any melee weapon, shield, or tool.", levels: ["Whenever you transform the weapon, your next attack deals +1d4 damage.", "Choose one bonus when transforming: Sword = +1d6 damage · Spear = +10 ft range · Hammer = push target 5 ft.", "You may transform once per turn without spending another Minor Action.", "Masterwork Arsenal — once per battle, instantly switch between forms at any time. Additionally gain all bonuses simultaneously for 2 turns."] },
      { name: "Enhancement", cost: "8 Δ", action: "Action", range: "10 ft", effect: "Empower a weapon, granting +1d6 damage for 2 turns.", levels: ["Damage bonus becomes +1d8 and lasts 3 turns.", "The empowered weapon ignores 2 AC.", "Choose one enhancement: Flaming (+1d8 fire) or Swift (may move 10 ft after attacking).", "Divine Masterpiece — once per battle, choose one ally. Their weapon gains +2d8 damage, ignores Guard, and critical hits inflict Exposed for 3 turns."] },
      { name: "Fire's Embrace", cost: "5 Δ", action: "Action", range: "Cone", effect: "Hammer strike creates a fiery cone and deals 1d6 fire damage.", levels: ["Leaves burning terrain. Entering the terrain deals 1d4 fire damage.", "Initial damage becomes 2d6.", "Enemies hit must roll d20. On a failed roll, they become Burning.", "Forge Eruption — once per battle, increase the cone to 20 ft. Deals 4d6 fire damage, Burning, pushes enemies 10 ft, and leaves lava terrain for 3 turns."] },
      { name: "Forge Scrap", cost: "Passive", action: "Passive", range: "Self", effect: "Whenever an enemy dies, an automaton dies, or a construct is destroyed, gain 1 Scrap Token. Maximum 5 Scrap Tokens.", levels: ["Spend 1 Scrap Token: gain 5 Guard.", "Spend 2 Scrap Tokens: heal an ally for 1d6.", "Spend 3 Scrap Tokens: deal 2d6 fire damage.", "Scrap remains capped at 5 unless another rule increases it."] },
    ],
  },
  {
    id: "aphrodite",
    name: "Aphrodite",
    sigil: "V",
    domain: "Of Love & Wrath · Desire & Ruin",
    ac: "+3 AC",
    color: "#D06BA0",
    abilities: [
      { name: "Lover's Paradise", cost: "8 Δ", action: "Action", range: "Self + ally", effect: "You and an ally gain +2 AC and 5 Guard for 3 turns (+1d4 Guard if Split Persona is active).", levels: ["Guard → +10.", "If Split Persona active, you and ally heal 1d4/turn.", "Choose two allies instead of one.", "If an ally would die, they hit 1 HP instead."] },
      { name: "Split Persona", cost: "5 Δ", action: "Action", range: "15 ft", duration: "2 turns", effect: "Summon a Persona. Joy: heal ally within 15 ft for 1d4. Unlock more incarnations per level.", levels: ["Unlock Sadness: target takes 1d4 psychic damage.", "Unlock Rage: target becomes Exposed.", "Unlock Fear: enemy moves away + disadvantage next turn.", "Personas last 3 turns."] },
      { name: "Self Reflection", cost: "8 Δ", action: "Action", range: "Active Personas", effect: "Supercharge active Personas — they deal psychic damage then meld back: 1 persona: 1d4 · 2: 2d4 + Exposed · 3: 3d4 + loses Reaction.", levels: ["Lv 2 details to be revealed.", "Lv 3 details to be revealed.", "Lv 4 details to be revealed.", "Lv 5 details to be revealed."] },
    ],
  },
  {
    id: "ares",
    name: "Ares",
    sigil: "W",
    domain: "Spear of Carnage · War & Fury",
    ac: "+3 AC",
    color: "#B22222",
    abilities: [
      { name: "Passion's Rage", cost: "4 Δ activate + 2 Δ/turn", action: "Minor Action", range: "Self", effect: "Unleash untold rage — your attacks deal +1d6 damage while active.", levels: ["Ongoing cost → 1 Δ/turn.", "Defeat an enemy → gain 5 Guard.", "Bonus damage → +1d8.", "Once per battle: when dropped to half HP or lower, make one free attack."] },
      { name: "Berserker's Fury", cost: "8 Δ", action: "Action", range: "20 ft", duration: "2 turns", effect: "Target rolls d20. On a failed roll, they enter a rage — can only basic attack the nearest creature.", levels: ["If they miss an attack they take 1d6 psychic damage.", "Choose which creature they rage on.", "Rage lasts 3 turns.", "Bosses below half HP also become Exposed."] },
      { name: "The Art of War", cost: "7 Δ", action: "Action", range: "30 ft", duration: "3 turns", effect: "Mark one enemy with spectral blades. First time they take damage each round → +1d6 blade damage.", levels: ["Spend 3 Δ to deal damage to last enemy attacked as Minor Action.", "Bonus damage → +1d8.", "Marked enemy takes 1d6 if they move.", "On marked enemy's defeat, mark jumps to another foe within 15 ft."] },
    ],
  },
  {
    id: "hermes",
    name: "Hermes",
    sigil: "M",
    domain: "Wind & Word · Speed & Trickery",
    ac: "+2 AC",
    color: "#D4AF37",
    abilities: [
      { name: "Back Alley", cost: "8 Δ", action: "Minor Action", range: "Self", duration: "2 turns", effect: "Your attacks ignore Guard, shields, and cover.", levels: ["After attacking, teleport up to 20 ft.", "First attack after teleporting deals +1d6.", "Teleport through walls or barriers you can see through.", "Once per battle: swap places with any enemy."] },
      { name: "Trade of Commerce", cost: "6 Δ", action: "Minor Action", range: "Self", effect: "Roll d6 for a divine find: potion, firework, smoke bomb, wing charm, coin trick, or unlucky find.", levels: ["Share items with allies or foes.", "Roll twice, choose one.", "Items upgrade from d6 to d8 results.", "Once per battle: choose the item instead of rolling."] },
      { name: "Gambler of Legend", cost: "5 Δ", action: "Action", range: "Self", effect: "Roll d20 for Bad Luck through Legend Roll, ranging from Exposed to an extra Action.", levels: ["Lv 2 details to be revealed.", "Lv 3 details to be revealed.", "Lv 4 details to be revealed.", "Lv 5 details to be revealed."] },
    ],
  },
  {
    id: "dionysus",
    name: "Dionysus",
    sigil: "N",
    domain: "Madness Crowned · Chaos & Revelry",
    ac: "+2 AC",
    color: "#9B6BD0",
    abilities: [
      { name: "Drunken Bloom", cost: "8 Δ", action: "Action", range: "30 ft", duration: "3 turns", effect: "Create two vine walls. Enemies next to walls attack with disadvantage.", levels: ["Enemies within 5 ft of wall take 1d4 damage.", "Allies next to wall gain 3 Guard/turn.", "Vines grab one enemy → Rooted.", "Once per battle: vines explode for 3d6 in 10 ft."] },
      { name: "Satyr's Indulgence", cost: "8 Δ", action: "Action", range: "20 ft", effect: "Enemies roll d20. On a failed roll, they lose their next Action. Allies may join — skip Action but heal 2d6 HP.", levels: ["Weak enemies that fail badly fight for you 1 turn.", "Allies who join also gain 5 Δ.", "Enemy failure becomes harder to resist.", "Once per battle: affected enemies become Charmed for 1 round after partying."] },
      { name: "Polymorph", cost: "10 Δ", action: "Action", range: "30 ft", effect: "Roll d20. On 15 or higher, the target becomes a sheep until end of their next turn.", levels: ["After transformation, target's HP decreases by 10.", "The transformation becomes easier to land.", "Target two weak enemies.", "Bosses below half HP can be transformed for 1 turn."] },
    ],
  },
];

export const GOD_MAP = Object.fromEntries(GODS.map((god) => [god.id, god]));